<table *ngIf="!!issueDateCount">
	<tr>
		<td>{{ "ORDER.PRICE_BREAKDOWN.NUMBER_OF_ISSUE_DATES" | translate }}</td>
		<td>{{ issueDateCount }}</td>
	</tr>
</table>
<hr *ngIf='isCalculating || message'>
<p *ngIf='isCalculating' class='message'>{{ "ORDER.PRICE_BREAKDOWN.CALCULATING" | translate }}...</p>
<p *ngIf='!isCalculating && message' class='message' [ngClass]="{'error': isError}">{{ message }}</p>
<cass-indeterminate-circular-progress-indicator *ngIf="isCalculating"></cass-indeterminate-circular-progress-indicator>
<table class='prices' *ngIf='!isCalculating && !message'>
	<tr *ngIf='priceMedia !== undefined'>
		<td>{{ "ORDER.PRICE_BREAKDOWN.MEDIA_PRICE" | translate }}</td>
		<td>= {{ priceMedia | cassCurrency:currencyCode }}</td>
	</tr>
	<tr *ngIf='surcharges !== undefined'>
		<td>{{ "ORDER.PRICE_BREAKDOWN.SURCHARGES" | translate }}</td>
		<td>+ {{ surcharges | cassCurrency:currencyCode }}</td>
	</tr>
	<tr *ngIf='priceGross !== undefined'>
		<td>{{ "ORDER.PRICE_BREAKDOWN.GROSS_PRICE" | translate }}</td>
		<td>= {{ priceGross | cassCurrency:currencyCode }}</td>
	</tr>
	<tr *ngIf='discounts !== undefined && discounts > 0'>
		<td>{{ "ORDER.PRICE_BREAKDOWN.DISCOUNTS" | translate }}</td>
		<td>&ndash; {{ discounts | cassCurrency:currencyCode }}</td>
	</tr>

	<ng-container *ngIf="!isDirect">
		<tr>
			<td>{{ "ORDER.PRICE_BREAKDOWN.PRICE_EX_COMMISSION" | translate }}</td>
			<td>= {{ netExCommission | cassCurrency:currencyCode }}</td>
		</tr>
		<tr>
			<td>{{ "ORDER.PRICE_BREAKDOWN.COMMISSION" | translate }}</td>
			<td>&ndash; {{ commissionAmount | cassCurrency:currencyCode }}</td>
		</tr>
	</ng-container>

	<ng-container *ngIf="tax !== undefined && tax > 0">
		<tr>
			<td>{{ "ORDER.PRICE_BREAKDOWN.PRICE_EX_TAX" | translate }}</td>
			<td>= {{ priceExTax | cassCurrency:currencyCode }}</td>
		</tr>
		<tr>
			<td>{{ "ORDER.PRICE_BREAKDOWN.TAX" | translate }}</td>
			<td>+ {{ tax | cassCurrency:currencyCode }}</td>
		</tr>
	</ng-container>

	<tr class='totalRow' *ngIf="priceIncTax !== undefined">
		<td>{{ (tax !== undefined && tax > 0 ? "ORDER.PRICE_BREAKDOWN.PRICE_INCLUDING_TAX" : "ORDER.PRICE_BREAKDOWN.NET_PRICE" ) | translate }}</td>
		<td>= {{ priceIncTax | cassCurrency:currencyCode }}</td>
	</tr>
</table>
<div class='custom-ts-subscriber-discount-panel' *ngIf="isCustomerNumberApplicable">
	<mat-checkbox [(ngModel)]="isCustomerNumberSectionShown">{{ "ORDER.PRICE_BREAKDOWN.ENTER_CUSTOMER_NUMBER_CHECKBOX" | translate }}</mat-checkbox>
	<div *ngIf="isCustomerNumberSectionShown" class="cass-customer-number-section">
		<mat-label class='enter-customer-number-label'>{{ "ORDER.PRICE_BREAKDOWN.ENTER_CUSTOMER_NUMBER_LABEL" | translate }}</mat-label>
		<mat-form-field>
			<mat-label>{{ "ORDER.PRICE_BREAKDOWN.ENTER_CUSTOMER_NUMBER_TEXTBOX_LABEL" | translate }}</mat-label>
			<input type="text" matInput [(ngModel)]="customerNumber" [disabled]="isCustomerNumberInputDisabled">
		</mat-form-field>
		<button mat-raised-button color='primary' type="button" *ngIf="!isCustomerNumberInputDisabled" [disabled]="!customerNumber" (click)="applyCustomerNumber()">{{ "ORDER.PRICE_BREAKDOWN.ENTER_CUSTOMER_NUMBER_APPLY_ACTION" | translate }}</button>
		<div class="cass-customer-number-message-section">
			<mat-icon *ngIf="discountAppliedMessage">check_circle</mat-icon>{{ discountAppliedMessage }}
		</div>
		<div class="cass-customer-number-error-section">
			<mat-icon *ngIf="discountFailedMessage">fmd_bad</mat-icon>{{ discountFailedMessage }}
		</div>
	</div>
</div>
